var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.5px",
    height: "22.5px",
    viewBox: "0 0 16.5 22.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Small/Terms-a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/NonStickyProgressBar/HotelDetails/1440",
    transform: "translate(-803.750000, -28.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Terms-a",
    transform: "translate(800.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.75 L13.5,7.5 L20.25,7.5 L20.25,23.25 L3.75,23.25 L3.75,0.75 L13.5,0.75 Z M8.25,17.25 L6.75,17.25 L6.75,18.75 L8.25,18.75 L8.25,17.25 Z M17.25,17.25 L9.75,17.25 L9.75,18.75 L17.25,18.75 L17.25,17.25 Z M8.25,14.25 L6.75,14.25 L6.75,15.75 L8.25,15.75 L8.25,14.25 Z M17.25,14.25 L9.75,14.25 L9.75,15.75 L17.25,15.75 L17.25,14.25 Z M8.25,11.25 L6.75,11.25 L6.75,12.75 L8.25,12.75 L8.25,11.25 Z M17.25,11.25 L9.75,11.25 L9.75,12.75 L17.25,12.75 L17.25,11.25 Z M15,0.75 L20.25,6 L15,6 L15,0.75 Z",
    id: "Combined-Shape",
    fill: "#CCCCCC"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsA);
export default __webpack_public_path__ + "static/media/Terms-a.57b4d949a0d6bf539c9e4c0fc897ea78.svg";
export { ForwardRef as ReactComponent };